import React from 'react';
import {MasterLayout} from 'components/layouts';
import BusinessZone from 'pages/my-business/BusinessZone.jsx';
import title from 'constants/TitlePages.js';
import {
  ListProduct
} from 'components/my-business/list-product';

import {BusinessLayout} from 'components/layouts/business';

class MyBusinessManageProductPage extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }

  componentDidMount() {
    document.title = title.MyBusinessManageProductPage;
  }

  render() {
    return (
      <MasterLayout>
        <BusinessLayout active='manage-product'>
          <ListProduct/>
        </BusinessLayout>
      </MasterLayout>
    );
  }
}

export default BusinessZone(MyBusinessManageProductPage);



// WEBPACK FOOTER //
// ./pages/my-business/MyBusinessManageProductPage.jsx